<div class="container">
  <div class="logo-wrapper">
    <img src="assets/img/Logo.svg" alt="Aguacate Wallet" />
  </div>

  <!-- Te invito alguien: se muestra en todo el wizard, no solo al entrar. El
       registro son quince pasos y el invitado tiene que ver hasta el final que
       su bono sigue en pie, si no la promesa del link se pierde por el camino. -->
  <div class="referido-bar" *ngIf="state?.llaveReferidor">
    <span class="referido-icon">&#127873;</span>
    <span class="referido-text">
      Te invit&oacute; <b>&#64;{{ state.llaveReferidor }}</b>.
      <ng-container *ngIf="fraseInvitacion">{{ fraseInvitacion }}</ng-container>
    </span>
  </div>

  <!-- Aviso de preview: solo se renderiza con ?preview=empresa y nunca en un
       build de produccion. Deja claro que ningun dato se guarda y permite
       saltar entre pantallas sin recorrer el flujo. -->
  <div class="preview-bar" *ngIf="preview.activo">
    <span class="preview-tag">PREVIEW</span>
    <span class="preview-text">Datos de prueba — nada se envía al backend</span>
    <div class="preview-jumps">
      <button
        type="button"
        *ngFor="let paso of pasosParaSaltar"
        class="preview-jump"
        [class.actual]="paso === currentStep"
        (click)="saltarAPaso(paso)"
        [attr.aria-current]="paso === currentStep ? 'step' : null"
        [attr.aria-label]="'Ir al paso ' + paso"
      >{{ paso }}</button>
    </div>
  </div>

  <ng-container *ngIf="showContent">
    <!-- Progress Bar (común a todos los pasos) -->
    <div class="progress-wrapper">
      <div class="progress-pill">Paso {{ currentStep }}/{{ totalSteps }}</div>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="progressPercentage"></div>
      </div>
    </div>

    <!-- Aviso de trabajo sin guardar.
         Es la unica pieza que puede DECIR que se pierde: el dialogo del
         navegador muestra su propio texto generico y no se puede personalizar.
         Solo aparece durante la captura de identidad de empresa, que es el
         tramo donde las imagenes viven en memoria (ver tieneTrabajoSinGuardar). -->
    <div class="unsaved-notice" *ngIf="tieneTrabajoSinGuardar()">
      <mat-icon>info_outline</mat-icon>
      <span>
        No cierres esta ventana: el documento y la selfie se guardan recién al
        terminar la verificación de identidad.
      </span>
    </div>

    <!-- Contenedor de pasos con transición -->
    <div class="step-container" [class.transitioning]="isTransitioning">

      <!-- PASO 1: Selección de tipo de cuenta -->
      <app-account-type-step *ngIf="currentStep === pasosEmpresa.TIPO_CUENTA"></app-account-type-step>

      <!-- PASO 2: Formulario de registro -->
      <app-registration-form-step
        *ngIf="currentStep === pasosEmpresa.FORMULARIO"
        (onError)="handleError($event)"
      ></app-registration-form-step>

      <!-- PASO 3: OTP Email (Cognito) -->
      <app-email-otp-step
        *ngIf="currentStep === pasosEmpresa.OTP_EMAIL"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-email-otp-step>

      <!-- PASO 4: OTP WhatsApp (KYC) -->
      <app-whatsapp-otp-step
        *ngIf="currentStep === pasosEmpresa.OTP_WHATSAPP"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-whatsapp-otp-step>

      <!-- PASO 5 (empresa): Carga del e-RUT de la empresa.
           Va primero: es el unico corte por empresa ya registrada y no
           necesita camara. Ver PASOS_EMPRESA en signup.constants.ts. -->
      <app-erut-upload-step
        *ngIf="currentStep === pasosEmpresa.ERUT && signupState.isEmpresa"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-erut-upload-step>

      <!-- PASO 6 (empresa): Verificación de identidad + consentimiento biométrico -->
      <app-empresa-consent-step
        *ngIf="currentStep === pasosEmpresa.CONSENTIMIENTO && signupState.isEmpresa"
      ></app-empresa-consent-step>

      <!-- PASO 7 (empresa): OCR del documento del representante legal -->
      <app-ocr-document-step
        *ngIf="currentStep === pasosEmpresa.OCR && signupState.isEmpresa"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-ocr-document-step>

      <!-- PASO 8 (empresa): Liveness / verificación facial -->
      <app-face-capture-step
        *ngIf="currentStep === pasosEmpresa.SELFIE && signupState.isEmpresa"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-face-capture-step>

      <!-- PASO 9 (empresa): Datos del representante legal -->
      <app-representante-legal-step
        *ngIf="currentStep === pasosEmpresa.REPRESENTANTE && signupState.isEmpresa"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-representante-legal-step>

      <!-- PASO 10 (empresa): Declaración PEP del representante legal -->
      <app-representante-pep-step
        *ngIf="currentStep === pasosEmpresa.PEP && signupState.isEmpresa"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-representante-pep-step>

      <!-- PASO 11 (empresa): Persona jurídica (2 sub-pasos) -->
      <app-persona-juridica-step
        *ngIf="currentStep === pasosEmpresa.PERSONA_JURIDICA && signupState.isEmpresa"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-persona-juridica-step>

      <!-- PASO 12 (empresa): Información del negocio -->
      <app-informacion-negocio-step
        *ngIf="currentStep === pasosEmpresa.NEGOCIO && signupState.isEmpresa"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-informacion-negocio-step>

      <!-- PASO 5: OCR Documento (solo personal) -->
      <app-ocr-document-step
        *ngIf="currentStep === pasosPersona.OCR && signupState.isPersonal"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-ocr-document-step>

      <!-- PASO 6: Verificación Facial (solo personal) -->
      <app-face-capture-step
        *ngIf="currentStep === pasosPersona.SELFIE && signupState.isPersonal"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-face-capture-step>

      <!-- PASO 7: Confirmación de Datos -->
      <app-data-confirmation-step
        *ngIf="currentStep === pasosPersona.CONFIRMACION && signupState.isPersonal"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-data-confirmation-step>

      <!-- PASO 8: Selección PEP -->
      <app-pep-selection-step
        *ngIf="currentStep === pasosPersona.PEP_SELECCION && signupState.isPersonal"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-pep-selection-step>

      <!-- PASO 9: Declaración PEP (solo si tiene vínculos) -->
      <app-pep-declaration-step
        *ngIf="currentStep === pasosPersona.PEP_DECLARACION && signupState.isPersonal && signupState.isPoliticamenteExpuesto"
        (onError)="handleError($event)"
        (onSuccess)="handleSuccess($event)"
      ></app-pep-declaration-step>

    </div>

    <!-- Success Message -->
    <div *ngIf="successMessage" class="floating-success">
      {{ successMessage }}
    </div>

    <!-- Loading Overlay -->
    <div class="full-screen-loading" *ngIf="loadingFull">
      <div class="spinner"></div>
    </div>
  </ng-container>

  <!-- Error Message (fuera de showContent para que se muestre siempre) -->
  <div *ngIf="errorMessage" class="floating-error">
    {{ errorMessage }}
  </div>
</div>
